import { Link } from 'gatsby'
import React from 'react'
import PropTypes from 'prop-types'

import EcogestureImage from './EcogestureImage'

const EcogestureCard = ({ title, slug }) => (
  <Link
    to={`/ecogestes/${slug}/`}
    className="w-full relative inline-block"
    style={{ height: '18em' }}
  >
    <div
      className="absolute left-0 bottom-0 shadow-sm rounded w-full h-full z-10"
      style={{
        backgroundImage:
          'linear-gradient(180deg,rgba(0,0,0,.3),rgba(0,0,0,.8))',
      }}
    ></div>
    <EcogestureImage
      title="Ecogeste"
      className="absolute left-0 top-0 w-full h-full z-0 object-cover"
    />
    <div className="p-4 absolute bottom-0 left-0 z-20">
      <h2 className="text-2xl font-semibold text-gray-100 leading-tight">
        {title}
      </h2>
    </div>
  </Link>
)

EcogestureCard.propTypes = {
  title: PropTypes.string,
  image: PropTypes.object,
  slug: PropTypes.string,
}

export default EcogestureCard
